import {OperatingSystem} from '../enums';
import {RuntimeCacheService} from '../services/runtime-cache.service';
import {NoteDetailRes} from '../contracts/v0/crm';
import {NgxCsvParser, NgxCSVParserError} from 'ngx-csv-parser';
import {map, Observable} from 'rxjs';
import {DateRange} from '../services/date-range.service';
import {groupBy} from '@yasc/yasc-material-components';
import {ApiDateAdapter} from './api-date-adapter';


export function getIcon(os: OperatingSystem): string {
    switch (os) {
        case OperatingSystem.Android:
            return "assets/icons/os/android-icon.png";
        case OperatingSystem.IOS:
            return "assets/icons/os/apple-iphone-icon.png";
        case OperatingSystem.MacOs:
            return "assets/icons/os/apple-icon.png";
        case OperatingSystem.Web:
            return "assets/icons/os/chrome.png";
        case OperatingSystem.Windows:
            return "assets/icons/os/windows-icon.png";
        case OperatingSystem.Linux:
            return "assets/icons/os/linux-ubuntu-icon.png";
    }
}

export function getIconPath(operatingSystem: OperatingSystem) {
    return getIcon(operatingSystem);
}

export declare type CompareFun = (a: any, b: any) => boolean;


export function groupByDate(comms: NoteDetailRes[]): Map<string, NoteDetailRes[]> {
    return groupBy(comms, x => ApiDateAdapter.toDateTimeUtc(x.communicatedOn))
}

export function parseCsv(parser: NgxCsvParser, file: File, config: any = {
    header: true,
    delimiter: ';',
    encoding: 'utf8'
}): Observable<any[]> {
    return parser.parse(file, config)
        .pipe(
            map(result => {
                if (result instanceof NgxCSVParserError) {
                    // TODO: handle and show error
                    return [];
                } else {
                    return result;
                }
            })
        )
}

export function displayNumber(number: number): string {
    if (number < 10)
        return '0' + number
    return number.toString()
}

declare global {
    interface Date {
        addMinutes(minutes: number): Date;

        addHours(hours: number): Date;

        addDays(days: number): Date;

        addMonth(months: number): Date;

        dateInRange(range: DateRange): boolean;
    }

    interface String {
        toPascalCase(): string
    }
}
Date.prototype.addMinutes = function (this, minutes: number): Date {
    if (!minutes) return this
    return new Date(this.getFullYear(),
        this.getMonth(),
        this.getDate(),
        this.getHours(),
        this.getMinutes() + minutes)
}

Date.prototype.addHours = function (this, hours: number): Date {
    if (!hours) return this
    return new Date(this.getFullYear(),
        this.getMonth(),
        this.getDate(),
        this.getHours() + hours,
        this.getMinutes(),)
}

Date.prototype.addDays = function (this, days: number): Date {
    if (!days) return this;
    return new Date(
        this.getFullYear(),
        this.getMonth(),
        this.getDate() + days);
}

Date.prototype.addMonth = function (this, months): Date {
    if (!months) return this;
    return new Date(
        this.getFullYear(),
        this.getMonth() + months,
        this.getDate());
}

Date.prototype.dateInRange = function (this, range: DateRange): boolean {
    if (!range) return false;

    let start = new Date(range.start.getFullYear(), range.start.getMonth(), range.start.getDate())
    let end = new Date(range.end.getFullYear(), range.end.getMonth(), range.end.getDate())
    let check = new Date(this.getFullYear(), this.getMonth(), this.getDate())
    return start.getTime() <= check.getTime() && check.getTime() <= end.getTime()
}

export function timeToDecimal(date: Date): number {
    return (date.getHours() * 100) + ((date.getMinutes() * 100) / 60)
}

String.prototype.toPascalCase = function (this): string {
    return this.replace(/(?:^|\s|_|-)([a-z])/g, (_, char) => char.toUpperCase())
        .replace(/[^a-zA-Z0-9]/g, "");
};
